function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1916(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31.25,
    height: 11.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.43625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 5.745
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.49,
    width: 31.25,
    height: 27.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 25.41
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 39.33,
    width: 31.25,
    height: 34.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.90625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 56.485
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 73.64,
    width: 31.25,
    height: 43.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 95.505
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 117.37,
    width: 31.25,
    height: 57.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 145.975
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 174.58,
    width: 31.25,
    height: 58.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 203.965
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 233.35,
    width: 31.25,
    height: 59.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 263.235
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 293.13,
    width: 31.25,
    height: 60.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4722222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 323.24
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 353.35,
    width: 31.25,
    height: 65.24,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 385.97
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 418.59,
    width: 31.25,
    height: 68.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 452.765
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 486.94,
    width: 31.25,
    height: 69.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.464285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 521.915
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 556.88,
    width: 31.25,
    height: 70.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.90625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 591.965
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 627.05,
    width: 31.25,
    height: 72.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.208333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.625,
    y: 663.525
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 0,
    width: 44,
    height: 52.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.285714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.25,
    y: 26.005
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.25,
    y: 0,
    width: 45.17,
    height: 52.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.64625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.83500000000001,
    y: 26.005
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.42,
    y: 0,
    width: 47.69,
    height: 52.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.96125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.265,
    y: 26.005
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.12,
    y: 0,
    width: 47.94,
    height: 52.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.848571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.09,
    y: 26.005
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.05,
    y: 0,
    width: 49.34,
    height: 52.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.72000000000003,
    y: 26.005
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.39,
    y: 0,
    width: 49.9,
    height: 52.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.34,
    y: 26.005
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 0,
    width: 51.28,
    height: 52.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.325714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.94,
    y: 26.005
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.58,
    y: 0,
    width: 52.4,
    height: 52.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.50125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.78,
    y: 26.005
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.98,
    y: 0,
    width: 53.33,
    height: 52.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.50125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.64500000000004,
    y: 26.005
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.31,
    y: 0,
    width: 55.66,
    height: 52.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.50125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 500.14,
    y: 26.005
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.97,
    y: 0,
    width: 56.41,
    height: 52.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.1750000000001,
    y: 26.005
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 584.38,
    y: 0,
    width: 57.14,
    height: 52.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.50125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.95,
    y: 26.005
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.52,
    y: 0,
    width: 58.48,
    height: 52.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.668333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.76,
    y: 26.005
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 52.01,
    width: 58.85,
    height: 55.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.593999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.675,
    y: 79.97999999999999
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 107.95,
    width: 58.85,
    height: 56.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.675,
    y: 136.4
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 164.84,
    width: 58.85,
    height: 59.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.675,
    y: 194.815
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 224.79,
    width: 58.85,
    height: 60.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.808333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.675,
    y: 254.81
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 284.83,
    width: 58.85,
    height: 62.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.675,
    y: 315.84999999999997
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 346.87,
    width: 58.85,
    height: 64.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.407142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.675,
    y: 379.035
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 411.2,
    width: 58.85,
    height: 71.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.675,
    y: 446.775
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 482.34,
    width: 58.85,
    height: 71.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.808333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.675,
    y: 518.18
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 554.02,
    width: 58.85,
    height: 71.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.407142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.675,
    y: 589.895
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 625.77,
    width: 58.85,
    height: 74.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.675,
    y: 662.885
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.1,
    y: 52.01,
    width: 67.15,
    height: 69.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.104545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.675,
    y: 86.645
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.25,
    y: 52.01,
    width: 68.4,
    height: 69.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.45,
    y: 86.645
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.65,
    y: 52.01,
    width: 70.78,
    height: 69.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.04,
    y: 86.645
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.43,
    y: 52.01,
    width: 78.65,
    height: 69.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.755,
    y: 86.645
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.08,
    y: 52.01,
    width: 79.11,
    height: 69.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.696666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.635,
    y: 86.645
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454.19,
    y: 52.01,
    width: 80.05,
    height: 69.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.895714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 494.215,
    y: 86.645
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 534.24,
    y: 52.01,
    width: 81.6,
    height: 69.27,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.7725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.04,
    y: 86.645
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 615.85,
    y: 52.01,
    width: 84.15,
    height: 69.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.65875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 657.9250000000001,
    y: 86.645
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.1,
    y: 121.28,
    width: 77.11,
    height: 76.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.963636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.655,
    y: 159.57999999999998
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.1,
    y: 197.87,
    width: 77.11,
    height: 79.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.015714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.655,
    y: 237.395
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.1,
    y: 276.92,
    width: 77.11,
    height: 79.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.851666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.655,
    y: 316.875
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.1,
    y: 356.83,
    width: 77.11,
    height: 80.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.015714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.655,
    y: 396.90999999999997
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.1,
    y: 436.98,
    width: 77.11,
    height: 84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.851666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.655,
    y: 478.98
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.1,
    y: 520.99,
    width: 77.11,
    height: 88.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.711
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.655,
    y: 565.255
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.1,
    y: 609.52,
    width: 77.11,
    height: 90.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.851666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.655,
    y: 654.76
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.21,
    y: 121.28,
    width: 70.92,
    height: 118.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0920000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.67000000000002,
    y: 180.45499999999998
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.13,
    y: 121.28,
    width: 86.88,
    height: 118.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.479999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.57,
    y: 180.45499999999998
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.01,
    y: 121.28,
    width: 111.4,
    height: 118.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.71,
    y: 180.45499999999998
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.41,
    y: 121.28,
    width: 121.93,
    height: 118.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.79375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 497.375,
    y: 180.45499999999998
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 558.35,
    y: 121.28,
    width: 141.65,
    height: 118.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.759090909090908
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 629.1750000000001,
    y: 180.45499999999998
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.21,
    y: 239.63,
    width: 142.63,
    height: 128.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.430000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.525,
    y: 303.92
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.21,
    y: 368.2,
    width: 142.63,
    height: 138.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.016666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.525,
    y: 437.25
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.21,
    y: 506.31,
    width: 142.63,
    height: 193.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.526
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.525,
    y: 603.155
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.84,
    y: 239.63,
    width: 111.07,
    height: 264.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.7675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.375,
    y: 372.08500000000004
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.91,
    y: 239.63,
    width: 279.09,
    height: 264.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 52.982000000000006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.455,
    y: 372.08500000000004
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.84,
    y: 504.54,
    width: 390.16,
    height: 195.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.4325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.91999999999996,
    y: 602.27
  }, "\n        New_York\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1916);
export default __webpack_public_path__ + "static/media/1916.4794d4c3109df02acdb67aaf7c3bedce.svg";
export { ForwardRef as ReactComponent };